import { api } from '@/services/api';

export default {
    namespaced: true,

    state: () => ({
        data: null,
        loading: false,
        error: null,
    }),

    mutations: {
            setLoading(state, val)    { state.loading = val; },
            setError(state, err)      { state.error = err;  },

            setUser(state, user)      { state.data = user; },
            clearUser(state)          { state.data = null; },
            updateCredits(state, val) {
                if (state.data) state.data.credits = val;
            },
    },

    actions: {
        async fetch({ commit }) {
            commit('setLoading', true);
            try {
                const { data } = await api.get('/current_user');
                commit('setUser', data);
            } catch (err) {
                commit('setError', err);
                commit('clearUser');
            } finally {
                commit('setLoading', false);
            }
        },

        async refreshCredits({ commit }) {
            try {
                const { data } = await api.get('/current_user');
                commit('updateCredits', data.credits);
            } catch (err) {
                console.error('❌ Failed to refresh credits:', err);
            }
        },
    },

    getters: {
        loggedIn  : state => Boolean(state.data),
        role      : state => state.data?.role ?? '',
        isTeacher : (state, g) => g.role === 'teacher',
        isStudent : (state, g) => g.role === 'student',
        credits   : state => state.data?.credits ?? 0,
        user      : state => state.data,
        isAdmin   : state => Boolean(state.data?.isAdmin),
    },
};
